import React from 'react';
import { ArrowRight } from 'lucide-react';
import * as LucideIcons from 'lucide-react';
import { services } from '../data/mock';
import { Link } from 'react-router-dom';

export const Services = () => {
  return (
    <div className="page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">Nos Services</h1>
          <p className="page-hero-description">
            Des prestations complètes pour l'entretien et l'aménagement de vos espaces verts
          </p>
        </div>
      </section>

      {/* Services Detail Section */}
      <section className="section-padding">
        <div className="container">
          <div className="services-detail-grid">
            {services.map((service, index) => {
              const Icon = LucideIcons[service.icon];
              return (
                <div 
                  key={service.id} 
                  className={`service-detail-card ${index % 2 === 0 ? 'service-detail-card-left' : 'service-detail-card-right'}`}
                >
                  <div className="service-detail-image">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="service-detail-icon">
                      {Icon && <Icon className="w-10 h-10" />}
                    </div>
                  </div>
                  <div className="service-detail-content">
                    <h3 className="service-detail-title">{service.title}</h3>
                    <p className="service-detail-description">{service.description}</p>
                    <ul className="service-detail-list">
                      <li>Intervention rapide et professionnelle</li>
                      <li>Matériel professionnel de qualité</li>
                      <li>Tarifs compétitifs et transparents</li>
                    </ul>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section-small">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title-small">Besoin d'un Devis ?</h2>
            <p className="cta-description">
              Contactez-nous pour discuter de votre projet
            </p>
            <Link to="/contact" className="btn-primary">
              Nous Contacter
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
